import { CASNotifications } from '../../../cimsPage/instances/cas'
import { Notifications } from '../../common'

const { Edit, View } = Notifications({
  page: CASNotifications,
  view: '2de8be72-b435-4bbf-8b34-f865f993643f',
  edit: 'e8995046-e752-4e5a-95b0-5c9c0d5bc7be',
})

export const ViewCASNotification = View
export const EditCASNotification = Edit

export type CASNotificationPermission =
  | typeof ViewCASNotification
  | typeof EditCASNotification
